import { Snippet, SnippetsSharingAccess } from '@distribute/shared/types';
import { snippetsModel } from '../../../../../../features/snippets';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from '../../../../../../shared/ui';

type Props = {
  snippet: Snippet;
  isOpen: boolean;
  onClose: () => void;
};

export const ChangePermissionConfirmationModal: FC<Props> = ({
  snippet,
  isOpen,
  onClose,
}) => {
  const dispatch = useDispatch();

  const updatingSnippetsData = useSelector(
    snippetsModel.selectors.selectUpdatingSnippetsData
  );

  const categories = useSelector(snippetsModel.selectors.selectCategories);

  const isLoading = useSelector(
    snippetsModel.selectors.selectIsUpdateSnippetLoading
  );

  const handleChangePermissionsConfirmationClose = () => {
    dispatch(snippetsModel.actions.setUpdatingSnippetData(undefined));
    onClose();
  };

  const updateSnippetFromPermissionConfirmation = () => {
    if (!updatingSnippetsData) {
      return;
    }
    dispatch(
      snippetsModel.actions.updateSnippet({
        snippet: snippet,
        snippetId: snippet.id,
        ...updatingSnippetsData,
        callback: () => {
          dispatch(snippetsModel.actions.setUpdatingSnippetData(undefined));
          onClose();
        },
      })
    );

    const category = categories.find(
      (c) => c.id === updatingSnippetsData.categoryId
    );

    dispatch(
      snippetsModel.actions.setCurrentSnippet({
        ...snippet,
        sharingAccess: updatingSnippetsData.sharingAccess,
        category:
          updatingSnippetsData.sharingAccess === SnippetsSharingAccess.PERSONAL
            ? null
            : category,
      })
    );
  };

  return (
    <Modal
      onClose={handleChangePermissionsConfirmationClose}
      isOpen={isOpen}
      isShowCancelButton
      title="Change Permissions"
      actionButton={
        <Button
          onClick={updateSnippetFromPermissionConfirmation}
          fullWidth
          type="submit"
          color="primary"
          variant="text"
          loading={isLoading}
        >
          Apply
        </Button>
      }
    >
      <p className="font-normal text-gray-600 text-s">
        Are you sure that you want to change the permissions of this snippet to
        public? Once done, it cannot be reverted back to personal.
      </p>
    </Modal>
  );
};
